import { defineStore } from "pinia";
// import axios from 'axios';
// import api from "@/api";
// import { API_BASE_URL } from "@/global-constants";
import { useMasterDataStore } from "./MasterDataStore";
export const useGolonganStore = defineStore("golonganStore", {
  state: () => ({
    data: null,
    golongans: null,
  }),
  getters: {
    filter() {
      return this.data.filter((g) => g.nama);
    },
  },
  actions: {
    async get() {
      // Fetch data only if it hasn't been fetched before

      // if (!this.data) {
      //   try {
      //     const config = {
      //       headers: {
      //         Authorization: api.defaults.headers.common["Authorization"],
      //         "content-type": "application/json",
      //       },
      //     };
      //     const response = await axios.get( `${API_BASE_URL}/golongan`,config);  // Replace with your API endpoint
      //     this.data = response.data;
      //   } catch (error) {
      //     console.error('golonganstore Error fetching pegawaiData:', error);
      //   }
      // }
      if (!this.data) {
        const master = useMasterDataStore();
        const masterData = await master.get();

        this.data = masterData.golongan || [];
        console.log("golonganStore", this.data);
      }

      return this.data;
    },
    // reset(){
    //     console.log("golonganStore clear")
    //     this.data = null;
    //     this.get();

    // }
    async reset() {
      // Add async
      this.data = null; // Clear the store

      const newData = await this.get(); // Fetch new data

      this.data = newData; // Store the fetched data
      return this.data; // Ensure reset() returns the data
    },
  },
  onInit() {
    this.get();
  },
  persist: true,
  onBeforeMount() {
    this.get();
  },
});
